// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SaveSelfStudyDECommentReleaseHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import SelfStudyDTO from '../models/SelfStudyDTO';
import AcademicYearDTO from '../models/AcademicYearDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    deCommentRelease: boolean;
    selfStudyId: string | null | null;
    academicYear: number | null | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            deCommentRelease: false,
            selfStudyId: null,
            academicYear: null,
        },
        initValues);
    },
    deCommentRelease: 'deCommentRelease',
    selfStudyId: 'selfStudyId',
    academicYear: 'academicYear',
}

interface Result extends ResultDTO {
    selfStudy: SelfStudyDTO | null;
    academicYear: AcademicYearDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            selfStudy: null,
            academicYear: null,
        },
        initValues);
    },
    selfStudy: 'selfStudy',
    academicYear: 'academicYear',
}

export { Request, Result };